import styled, { css } from 'styled-components';
import { grey } from '@material-ui/core/colors';
import { SwiperSlide } from 'swiper/react';

export const StyledSwiperSlide = styled(SwiperSlide)`
  display: flex;
`;

export const GalleryWrapper = styled.div`
  display: block;
  box-sizing: border-box;
  margin: 1em 0;
  outline: none;
  width: 100%;
  .swiper-container {
    margin-bottom: 0.5em;
    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 30%;
      height: auto;
      margin: 0;
      padding: 1em;
      color: ${grey[200]};
      outline: none;
    }
    .swiper-button-prev {
      right: auto;
      left: 0;
      justify-content: flex-start;
    }
    .swiper-button-next {
      right: 0;
      left: auto;
      justify-content: flex-end;
    }
  }

  .swiper-slide {
    opacity: 0.4;
  }

  .swiper-slide-active {
    opacity: 1;
  }

  .swiper-slide-thumb-active {
    opacity: 1;
  }
`;

export const SlideWrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  background-color: ${grey[400]};
  border-radius: 6px;
  min-width: 200px;
  min-height: 400px;

  ${(props) => props.thumb
    && css`
      min-width: 5rem;
      min-height: 4rem;
      transition: opacity 0.3s ease;
    `}
  ${(props) => props.bgImage
    && css`
      background-image: url('${props.bgImage}');
      background-repeat: no-repeat;
      background-size: cover;
    `}
`;
